// Dispatcher canônico (fan-out direto — Opção A).
//
// track() é fire-and-forget: monta o payload canônico com event_id (UUID v4),
// e DEFERE o fan-out com setTimeout(fn, 0) para nunca concorrer com o fluxo do
// usuário. Cada adapter roda em try/catch isolado — erro em analytics NUNCA
// impede o usuário de seguir nem afeta os outros destinos.
import { EVENTOS } from "./eventos";
import { uuidv4 } from "./uuid";
import { sendGtm } from "./adapters/gtm";
import { sendPixel } from "./adapters/pixel";
import { sendClarity } from "./adapters/clarity";
import { logDispatch, logAdapterError } from "./debug";

function fanout(meta, payload) {
  logDispatch(meta, payload);
  try { sendGtm(meta, payload); } catch (e) { logAdapterError("gtm", payload, e); }
  try { sendPixel(meta, payload); } catch (e) { logAdapterError("pixel", payload, e); }
  try { sendClarity(meta, payload); } catch (e) { logAdapterError("clarity", payload, e); }
}

export function track(evento, params = {}) {
  const meta = EVENTOS[evento];
  if (!meta) return; // evento desconhecido -> no-op silencioso

  const payload = {
    event: evento,
    event_id: uuidv4(),
    ...(meta.funnel_stage ? { funnel_stage: meta.funnel_stage } : {}),
    ...params,
  };

  setTimeout(() => fanout(meta, payload), 0);
}

export default track;
